import createCache from '@emotion/cache';
export default function createEmotionCache() {
    return createCache({
        prepend: true,
        key: 'emocache',
    });
}
